import Subscribe from '@/modules/link-in-bio/components/subscribe';
import Share from '../../../../link-in-bio/components/share';
import MailingIntegration from '../../mailing-integration';
import Avatar from './Avatar';
import Details from './Details';
import useAuth from '@/modules/auth/hooks/useAuth.hook';
import { useSearchParams } from 'react-router-dom';

const Profile = () => {
  const { state } = useAuth();
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');

  return (
    <div className="relative flex flex-col items-center justify-center w-full">
      {state.isAuthenticated ? <MailingIntegration /> : null}
      <Subscribe />
      {username ? null : <Share />}
      <Avatar />
      <Details />
    </div>
  );
};

export default Profile;
